module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/bath-816abc1997d903ad927a82ed040b5186.webp";